"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DownloadIcon = function DownloadIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 14.375V15.625C5 16.2682 5.48182 16.75 6.125 16.75H13.875C14.5182 16.75 15 16.2682 15 15.625V14.375",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 3.75V12.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.5 10L10 12.5L12.5 10",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _default = DownloadIcon;
exports["default"] = _default;